export default __webpack_public_path__ + "static/media/leo_phillips.4a238dd1.jpg";